const { createClientModuleProxy } = require("react-server-dom-turbopack/server.edge");

__turbopack_context__.n(createClientModuleProxy("[project]/node_modules/next/dist/client/script.js <module evaluation>"));
